export default "__VITE_ASSET__CNGH8ILf__"